import { createSelector } from '@reduxjs/toolkit';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { selectors as filtersSelectors } from '../Modules/filters';
import { getGlobalDepartmentRecords } from 'selectors/globalSelectors';
import { getGlobalDepartments } from 'utils/personnelHelper';
import { transform as transformList } from 'utils/DataTransform/Patrols/PatrolDefList';
import { transform as transformSiteList } from 'utils/DataTransform/Sites/SitesList';
import { transformPatrolDefDetails as transformDetails } from 'utils/DataTransform/Patrols/PatrolDefDetails';
import isEmpty from 'lodash/isEmpty';
import { getSiteListRaw } from 'containers/Pages/Locations/Sites/Selectors/siteSelectors';

export const getPatrolTemplateListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  getGlobalDepartmentRecords,
  (patrolTemplateList, globalDepartmentRecords) => {
    if (!patrolTemplateList) return [];
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    return transformList(patrolTemplateList, globalDepartmentList);
  },
);
export const getTotalEntries = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    if (!rowsCount) {
      return 0;
    }
    return rowsCount;
  },
);
// status of list refresh
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);

export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);
export const getPatrolTemplateFilters = createSelector(
  filtersSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);
export const getPatrolTemplateDetailTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getSiteListRaw,
  getGlobalDepartmentRecords,
  (data, siteList, globalDepartmentRecords) => {
    if (isEmpty(data)) {
      return {};
    }
    // convert it into id and name list array
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    // transform site list
    const transformedSiteList = transformSiteList(siteList);
    const details = transformDetails({
      data,
      siteList: transformedSiteList,
      globalDepartmentList,
    });
    return details;
  },
);

export const getPatrolTemplateDetailRaw = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => details,
);

export const getPatrolTaskList = createSelector(
  getPatrolTemplateDetailRaw,
  data => {
    if (isEmpty(data)) {
      return {};
    }
    // make an object of key value pairs of accessible task ids and the whole task object
    const patrolEvidenceTaskList = data?.patrolEvidenceList?.reduce(
      (prev, curr) => {
        prev[curr.tasks[0].id] = curr;
        return prev;
      },
      {},
    );
    return patrolEvidenceTaskList;
  },
);

export const getPatrolFirstLocation = createSelector(
  getPatrolTemplateDetailRaw,
  details => {
    return details.firstLocation;
  },
);
export const getPatrolOtherLocations = createSelector(
  getPatrolTemplateDetailRaw,
  details => {
    return details.locations;
  },
);
